module.exports = __webpack_public_path__ + "img/grinning-face-with-smiling-eyes.de980ab0.png";